import { render, staticRenderFns } from "./baojia.vue?vue&type=template&id=560faa65&scoped=true"
import script from "./baojia.vue?vue&type=script&lang=js"
export * from "./baojia.vue?vue&type=script&lang=js"
import style0 from "./baojia.vue?vue&type=style&index=0&id=560faa65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560faa65",
  null
  
)

export default component.exports